import Plugins from 'src/sections/@dashboard/plugins';

export default function PluginsPage() {
    return <Plugins />;
}
